import React, { useCallback } from "react";
import { Typography } from "@mui/material";
import { MinusIcon } from "shared/icons/MinusIcon";
import { PlusIcon } from "shared/icons/PlusIcon";

export const CounterInput = (props: CounterInputProps) => {
  const { value = 1, onChange, min = 0, max = 100 } = props;

  const increment = useCallback(() => onChange(value + 1), [value, onChange]);
  const decrement = useCallback(() => onChange(value - 1), [value, onChange]);
  return (
    <div className="module-counter-input">
      <button onClick={decrement} disabled={value <= min}>
        <MinusIcon />
      </button>
      <Typography>{value}</Typography>
      <button onClick={increment} disabled={value >= max}>
        <PlusIcon />
      </button>
    </div>
  );
};

interface CounterInputProps {
  onChange: (value: number) => void;
  value?: number;
  min?: number;
  max?: number;
}
